/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Typography } from '@mui/material';
import { AnimatedOnScroll } from 'react-animated-css-onscroll';
import ReactMarkdown from 'react-markdown';

// Styles
const useStyles = makeStyles((theme) => ({
  image: {
    position: 'relative',
    height: 350,
    zIndex: 101,
    marginBottom: theme.spacing(20),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(4),
    },
  },
  mainTitle: {
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    textAlign: 'left',
    marginBottom: 50,
    [theme.breakpoints.down('md')]: {
      marginBottom: 10,
    },
  },
  header: {
    color: theme.palette.interactive.main,
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  smallSubHeader: {
    textAlign: 'left',
    fontSize: 18,
    marginTop: 5,
    marginLeft: 10,
  },
  priorityTitle: {
    textAlign: 'left',
    fontSize: 18,
    marginTop: 5,
    marginBottom: 15,
  },
  valuesHeader: {
    color: theme.palette.primary.main,
    textAlign: 'left',
    fontSize: 30,
    marginTop: 16,
  },
  backgroundBox: {
    position: 'absolute',
    zIndex: 1,
    backgroundColor: theme.palette.alternative.main,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  mainBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
    },
  },
  bodyText: {
    fontFamily: 'Flama-Book',
    fontSize: '18px',
    lineHeight: 1.7,
  },
  paragraph: {
    height: 300,
    [theme.breakpoints.down('md')]: {
      height: 400,
    },
  },
  block: {
    display: 'block',
  },
  iconImages: {
    position: 'relative',
    height: 30,
    width: 30,
    zIndex: 101,
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(4),
    },
  },
  prioritiesLine: {
    display: 'flex',
    marginBottom: 10,
  },
  imageTag: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}));

const MissonVisionValues = (props) => {
  const classes = useStyles();
  const { data } = props;
  const scrollRef = useRef();
  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.search === '?id=1') {
      window.scrollTo(0, scrollRef.current.offsetTop - 60);
    }
  }, []);

  return (
    <Box ref={scrollRef} pt={{ xs: 4, md: 14 }} position="relative">
      <Box className={classes.mainBox}>
        <Grid container alignItems="flex-start" spacing={4}>
          <Grid item xs={12}>
            <Box position="relative" zIndex="100">
              <AnimatedOnScroll animationIn="fadeIn" animationInDuration={1000}>
                <Typography variant="h5" className={classes.header}>{data.missonVisionValuesTitle1}</Typography>
                <Typography variant="h3" className={classes.mainTitle}>{data.missonVisionValuesSubTitle1}</Typography>
              </AnimatedOnScroll>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
            <Box position="relative">
              <AnimatedOnScroll className={classes.image} animationIn="fadeIn" animationInDuration={1000}>
                <Box className={classes.image}>
                  <img src={data ? data.visionPicture.url : '/'} className={classes.imageTag} alt="Vision" />
                </Box>
              </AnimatedOnScroll>
              <AnimatedOnScroll animationIn="fadeIn" animationInDuration={500} screenOffset={-350}>
                <Box
                  className={classes.backgroundBox}
                  top={60}
                  left={100}
                  width={700}
                  height={400}
                />
              </AnimatedOnScroll>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
            <Box position="relative" zIndex="100">
              <AnimatedOnScroll animationIn="fadeIn" animationInDuration={1000}>
                <Typography variant="h3" className={classes.header}>Vision</Typography>
                <ReactMarkdown variant="h6" className={classes.bodyText}>{data.visionDescription1}</ReactMarkdown>
              </AnimatedOnScroll>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} order={{ xs: 3, md: 3 }}>
            <Box position="relative" zIndex="100">
              <AnimatedOnScroll animationIn="fadeIn" animationInDuration={1000}>
                <Typography variant="h3" className={classes.header}>Mission</Typography>
                <ReactMarkdown className={classes.bodyText}>{data.missonDescription}</ReactMarkdown>
                <Typography variant="h6" className={classes.priorityTitle}>{data.missonSubTitle2}</Typography>
                <Box className={classes.prioritiesLine}>
                  <Box className={classes.iconImages}>
                    <img src={data ? data.missionSafetyPicture.url : '/'} className={classes.imageTag} alt="Vision" />
                  </Box>
                  <Typography variant="h6" className={classes.smallSubHeader}>{data.missionSafety}</Typography>
                </Box>
                <Box className={classes.prioritiesLine}>
                  <Box className={classes.iconImages}>
                    <img src={data ? data.missionPunctualityPicture.url : '/'} className={classes.imageTag} alt="Vision" />
                  </Box>
                  <Typography variant="h6" className={classes.smallSubHeader}>{data.missionPunctuality}</Typography>
                </Box>
                <Box className={classes.prioritiesLine}>
                  <Box className={classes.iconImages}>
                    <img src={data ? data.missionServicePicture.url : '/'} className={classes.imageTag} alt="Vision" />
                  </Box>
                  <Typography variant="h6" className={classes.smallSubHeader}>{data.missionService}</Typography>
                </Box>
              </AnimatedOnScroll>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} order={{ xs: 4, md: 4 }}>
            <Box position="relative">
              <AnimatedOnScroll className={classes.image} animationIn="fadeIn" animationInDuration={1000}>
                <Box className={classes.image}>
                  <img src={data ? data.missonPicture.url : '/'} className={classes.imageTag} alt="Mission" />
                </Box>
              </AnimatedOnScroll>
              <AnimatedOnScroll animationIn="fadeIn" animationInDuration={500} screenOffset={-350}>
                <Box className={classes.backgroundBox} top={60} left={-300} width={700} height={450} />
              </AnimatedOnScroll>
            </Box>
          </Grid>
          <Grid item xs={12} md={4} order={{ xs: 6, md: 5 }}>
            <Box position="relative">
              <AnimatedOnScroll className={classes.image} animationIn="fadeIn" animationInDuration={1000}>
                <Box className={classes.image}>
                  <img src={data ? data.valuesPicture.url : '/'} className={classes.imageTag} alt="Values" />
                </Box>
              </AnimatedOnScroll>
              <AnimatedOnScroll animationIn="fadeIn" animationInDuration={500} screenOffset={-350}>
                <Box
                  className={classes.backgroundBox}
                  top={40}
                  left={250}
                  width={600}
                  height={400}
                />
              </AnimatedOnScroll>
            </Box>
          </Grid>
          <Grid item xs={12} md={12} order={{ xs: 6, md: 4 }}>
            <Typography variant="h3" className={classes.header}>Values</Typography>
          </Grid>
          <Grid item xs={12} md={4} order={{ xs: 6, md: 5 }}>
            <Box position="relative" zIndex="100">
              <AnimatedOnScroll animationIn="fadeIn" animationInDuration={1000}>
                <Grid container className={classes.block}>
                  <Grid item xs={12} className={classes.paragraph}>
                    <Typography variant="h6" className={classes.valuesHeader}>{data.valuesTitle2}</Typography>
                    <ReactMarkdown className={classes.bodyText}>{data.valuesDescription2}</ReactMarkdown>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h6" className={classes.valuesHeader}>{data.valuesTitle1}</Typography>
                    <ReactMarkdown className={classes.bodyText}>{data.valuesDescription1}</ReactMarkdown>
                  </Grid>
                </Grid>
              </AnimatedOnScroll>
            </Box>
          </Grid>
          <Grid item xs={12} md={4} order={{ xs: 6, md: 5 }}>
            <Box position="relative" zIndex="100">
              <AnimatedOnScroll animationIn="fadeIn" animationInDuration={1000}>
                <Grid container className={classes.block}>
                  <Grid item xs={12} className={classes.paragraph}>
                    <Typography variant="h6" className={classes.valuesHeader}>{data.valuesTitle4}</Typography>
                    <ReactMarkdown className={classes.bodyText}>{data.valuesDescription4}</ReactMarkdown>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h6" className={classes.valuesHeader}>{data.valuesTitle3}</Typography>
                    <ReactMarkdown className={classes.bodyText}>{data.valuesDescription3}</ReactMarkdown>
                  </Grid>
                </Grid>
              </AnimatedOnScroll>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default MissonVisionValues;
